import React from 'react';
import { motion } from 'framer-motion';

const PointsCard: React.FC = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="bg-white/10 backdrop-blur-md rounded-2xl shadow-xl overflow-hidden border border-white/20"
    >
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-[#7B1FA2]/20 to-[#40E0D0]/20 z-0" />
        
        <div className="grid grid-cols-1 md:grid-cols-3 relative z-10">
          <motion.div 
            className="p-8 md:border-r border-white/10 flex flex-col items-center justify-center"
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="relative mb-4">
              <motion.div
                className="w-20 h-20 rounded-full bg-gradient-to-br from-[#7B1FA2] to-[#40E0D0] flex items-center justify-center shadow-lg"
                whileHover={{ rotate: [0, -10, 10, -10, 0] }}
                transition={{ duration: 0.5 }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </motion.div>
              <motion.div 
                className="absolute -right-1 -top-1 w-6 h-6 bg-white rounded-full flex items-center justify-center shadow-md"
                initial={{ scale: 0 }}
                animate={{ scale: [0, 1.2, 1] }}
                transition={{ delay: 0.5, duration: 0.5 }}
              >
                <span className="text-[#007BFF] text-xs font-bold">+</span>
              </motion.div>
            </div>
            <h3 className="text-xl font-bold text-center mb-1">360</h3>
            <p className="text-white/80 text-center">Points accumulés</p>
          </motion.div>
          
          <motion.div 
            className="p-8 md:border-r border-white/10 flex flex-col items-center justify-center"
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="relative mb-4">
              <motion.div
                className="w-20 h-20 rounded-full bg-gradient-to-br from-[#7B1FA2] to-[#40E0D0] flex items-center justify-center shadow-lg"
                whileHover={{ rotate: [0, -10, 10, -10, 0] }}
                transition={{ duration: 0.5 }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                </svg>
              </motion.div>
            </div>
            <h3 className="text-xl font-bold text-center mb-1">12</h3>
            <p className="text-white/80 text-center">Achats enregistrés</p>
          </motion.div>
          
          <motion.div 
            className="p-8 flex flex-col items-center justify-center"
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="relative mb-4">
              <motion.div
                className="w-20 h-20 rounded-full bg-gradient-to-br from-[#7B1FA2] to-[#40E0D0] flex items-center justify-center shadow-lg"
                whileHover={{ rotate: [0, -10, 10, -10, 0] }}
                transition={{ duration: 0.5 }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </motion.div>
              <motion.div 
                className="absolute -right-1 -top-1 w-6 h-6 bg-white rounded-full flex items-center justify-center shadow-md"
                initial={{ scale: 0 }}
                animate={{ scale: [0, 1.2, 1] }}
                transition={{ delay: 0.6, duration: 0.5 }}
              >
                <span className="text-[#007BFF] text-xs font-bold">3</span>
              </motion.div>
            </div>
            <h3 className="text-xl font-bold text-center mb-1">3</h3>
            <p className="text-white/80 text-center">Offres disponibles</p>
          </motion.div>
        </div>
        
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="h-1 bg-gradient-to-r from-[#7B1FA2] to-[#40E0D0] transform origin-left"
        />
      
        <div className="p-6 flex justify-between items-center">
          <div>
            <h3 className="text-sm font-medium text-white/80">Prochaine récompense</h3>
            <p className="text-lg font-semibold">Encore 140 points</p>
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-lg hover:bg-white/30 transition-colors"
          >
            Voir toutes les récompenses
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

export default PointsCard;
